// user
export const AUTHORIZATION = "authorization";
export const USER_EDIT_PASSWORD = "user/edits/password";

// directory
export const GET_DIR = "mega/get/dir";

// folder
export const CREATE_FOLDER = "mega/create/folder";
export const DELETE_FOLDER = "mega/deleted/folder";
export const RENAME_FOLDER = "mega/rename/folder";

// file
export const UPLOAD_FILE = "mega/upload/file";
export const DELETE_FILE = "mega/deleted/file";
export const SHARE_FILE = "mega/share/file";
export const RENAME_FILE = "mega/rename/file";

// alternative file
export const ALTERNATIVE_FILE = "mega/show/list/alternative/file";

// sharemanagement list
export const SHAREMANAGEMENT_LIST = "mega/share/management/list";
export const DELETE_SHAREMANAGEMENT_LIST = "mega/delete/share/file";
export const UPDATE_SHAREMANAGEMENT_COUNT = "mega/update/count";

// usermanagement list
export const USERMANAGEMENT_LIST = "users";
export const DELETE_USERMANAGEMENT_LIST = "user/delete";
export const UPDATE_USERMANAGEMENT = "user/edits";
export const UPDATE_USERMANAGEMENT_ADMIN = "user/edits/password";
export const CREATE_USERMANAGEMENT = "user/add";

// search
export const SEARCH_FILE_FOLDER = "mega/search/file/folder";

// download
export const GET_TARGET_INFO = "mega/get/target/info";
export const CHECK_PASSWORD_FILE = "mega/check/password/file";

// reports
export const GET_REPORTS_LIST = "mega/list/download/file";

// sub reports
export const GET_SUB_REPORTS = "mega/sub/list/download";
